var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsLeftSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.27733 3.46636L-1.59495 6.41534L-2.51121 1.69673C-0.612624 0.772892 1.79791 0.144634 4.67219 0.158184L7.43016 3.92011L7.44929 0.340061C9.57694 0.595874 11.9811 1.16097 14.597 2.14754C14.597 2.14754 10.8756 5.8345 5.67519 8.66758L2.03234 4.99328L3.11135 9.95547C-1.09983 11.8634 -5.93748 12.8859 -10.3571 11.0824C-10.3571 11.0824 -9.21046 6.73183 -5.27733 3.46636Z",
    fill: "#FFBA94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1464 12.0431L27.2369 18.1079L23.259 19.5014L14.6286 11.3643L16.5266 21.7871L14.2587 22.5912L9.68021 18.3035L10.6405 23.8233L-0.520002 27.6452C-0.520002 27.6452 -2.40371 14.2112 11.1256 8.56991C24.6184 2.87402 34.6741 8.47919 39.4418 13.9833L31.1975 16.805L26.1464 12.0431Z",
    fill: "#FFBA94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsLeftSmall);
export default __webpack_public_path__ + "static/media/palmLeafsLeftSmall.1488f6d7c3e4f9e3360e1ecf12e23116.svg";
export { ForwardRef as ReactComponent };